import { render, staticRenderFns } from "./MarcheWalletBalanceIndex.vue?vue&type=template&id=7d7eb5d0&scoped=true"
import script from "./MarcheWalletBalanceIndex.vue?vue&type=script&lang=js"
export * from "./MarcheWalletBalanceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7eb5d0",
  null
  
)

export default component.exports